import { clinicsUrl, entitiesUrl, usersUrl } from 'infra/config/aws-env'
import { HttpClient } from 'infra/http/usecases/http-client'
import { GenericSelector } from './usecases/generic-selector'
import { GetClinics } from './usecases/get-clinics'
import { TypeaheadItem } from 'presentation/components/typeahead/typeahead'
import { GetOncologistsParams, Oncologist, OncologistsResponse } from 'domain/usecases/get-oncologists'

export class ClinicsService implements GetClinics {
  constructor(private baseUrl: string, private httpClient: HttpClient) {}

  getClinics(): Promise<GenericSelector[]> {
    return this.httpClient
      .request({
        headers: {
          'Content-Type': 'application/json',
        },
        type: 'get',
        url: `${this.baseUrl}${clinicsUrl.getClinics}`,
      })
      .then((clinicsList) => clinicsList)
      .catch((error) => error)
  }

  getClinicInfo(clinic_id: string): Promise<GenericSelector> {
    return this.httpClient
      .request({
        headers: {
          'Content-Type': 'application/json',
        },
        type: 'get',
        url: `${this.baseUrl}${clinicsUrl.getClinicInfo}?clinic_id=${clinic_id}`,
      })
      .then((clinicInfo) => clinicInfo)
      .catch((error) => error)
  }

  getOncologists(params: GetOncologistsParams): Promise<OncologistsResponse> {
    return new Promise((resolve) => {
      this.httpClient
        .request({
          type: 'get',
          headers: {},
          url: `${this.baseUrl}${usersUrl.oncologists}${this.getQueryString(params)}`,
        })
        .then((result) => resolve(result))
        .catch(() => resolve({ items: [], page: 1, size: 10, total: 0 }))
    })
  }

  private getQueryString(params: Partial<GetOncologistsParams>) {
    return `?page=${params.page}&size=${params.size}&search=${params.search}&clinic_id=${params.clinic_id}`
  }
}
